module.exports = __webpack_public_path__ + "static/img/glove_rose_indien.b264de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colors/women/glove_rose_indien.png
// module id = fN37
// module chunks = 0